import { formatWebVitalsPayload } from '@preqin/preqin-core/cjs/utils/webMetrics/webVitalsUtils';

import packageJson from '../package.json';

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry); //Cumulative Layout Shift
      getFID(onPerfEntry); //First Input Delay
      getFCP(onPerfEntry); //First Contentful Paint
      getLCP(onPerfEntry); //Largest Contentful Paint
      getTTFB(onPerfEntry); //Time to First Byte.
    });
  }
};
export default reportWebVitals;

//Send Metrics to Analytics Platform
export function sendToAnalytics(metric) {
  const currentUser = window.__preqinUser;
  if (!currentUser) {
    return null;
  }

  const formattedData = formatWebVitalsPayload({
    metric,
    appName: 'preqin.com.client.term.intelligence',
    mfeAppName: packageJson.name,
    location, // eslint-disable-line
    user: currentUser ? currentUser : null,
  });

  const body = JSON.stringify({ ...formattedData });
  (navigator.sendBeacon && navigator.sendBeacon(window._env_.ANALYTICS_URL, body)) ||
    fetch(window._env_.ANALYTICS_URL, { body, method: 'POST', keepalive: true });
}
